/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const viMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Đăng nhập',
  'user.register': 'Đăng ký',
  'user.forgot-password': 'Quên mật khẩu',
  'user.email': 'E-mail',
  'user.newpassword': 'Mật khẩu mới',
  'user.currentpassword': 'Mật khẩu hiện tại',
  'user.newpasswordagain': 'Nhập lại mật khẩu mới',
  'user.password': 'Mật khẩu',
  'user.forgot-password-question': 'Quên mật khẩu?',
  'user.fullname': 'Họ và tên',
  'user.firstname': 'Tên',
  'user.lastname': 'Họ',
  'user.login-button': 'ĐĂNG NHẬP',
  'user.register-button': 'ĐĂNG KÝ',
  'user.reset-password-button': 'ĐẶT LẠI',
  'user.buy': 'MUA',
  'user.username': 'Tên đăng nhập',

  /* 03.Menu */
  'menu.app': 'Trang chủ',

  'menu.default': 'Mặc định',
  'menu.analytics': 'Phân tích',
  'menu.ecommerce': 'Thương mại điện tử',
  'menu.content': 'Nội dung',
  'menu.pages': 'Trang',
  'menu.data-list': 'Danh sách dữ liệu',
  'menu.thumb-list': 'Danh sách hình thu nhỏ',
  'menu.image-list': 'Danh sách hình ảnh',
  'menu.details': 'Chi tiết',
  'menu.search': 'Tìm kiếm',
  'menu.login': 'Đăng nhập',
  'menu.register': 'Đăng ký',
  'menu.forgot-password': 'Quên mật khẩu',
  'menu.error': 'Lỗi',
  'menu.applications': 'Ứng dụng',
  'menu.todo': 'Danh sách việc cần làm',
  'menu.survey': 'Khảo sát',
  'menu.chat': 'Trò chuyện',
  'menu.ui': 'Giao diện người dùng',
  'menu.edit': 'Chỉnh sửa',
  'menu.alerts': 'Cảnh báo',
  'menu.badges': 'Huy hiệu',
  'menu.buttons': 'Nút bấm',
  'menu.cards': 'Thẻ',
  'menu.carousel': 'Băng chuyền',
  'menu.charts': 'Biểu đồ',
  'menu.collapse': 'Thu gọn',
  'menu.dropdowns': 'Danh sách thả xuống',
  'menu.editors': 'Trình soạn thảo',
  'menu.form-layouts': 'Bố cục biểu mẫu',
  'menu.form-components': 'Thành phần biểu mẫu',
  'menu.form-validations': 'Xác thực biểu mẫu',
  'menu.icons': 'Biểu tượng',
  'menu.input-groups': 'Nhóm nhập liệu',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Điều hướng',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Có thể sắp xếp',
  'menu.tables': 'Bảng',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Ẩn phụ',
  'menu.hidden': 'Ẩn',
  'menu.visible': 'Hiện',
  'menu.maps': 'Bản đồ',
  'menu.landingpage': 'Trang đích',
  'menu.multipage-home': 'Trang chủ đa trang',
  'menu.singlepage-home': 'Trang chủ đơn trang',
  'menu.about': 'Giới thiệu',
  'menu.auth-login': 'Xác thực đăng nhập',
  'menu.auth-register': 'Xác thực đăng ký',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Chi tiết blog',
  'menu.careers': 'Nghề nghiệp',
  'menu.confirmation': 'Xác nhận',
  'menu.contact': 'Liên hệ',
  'menu.docs': 'Tài liệu',
  'menu.features': 'Tính năng',
  'menu.prices': 'Bảng giá',
  'menu.videos': 'Video',
  'menu.mailing': 'Gửi thư',
  'menu.invoice': 'Hóa đơn',
  'menu.blank-page': 'Sắp ra mắt...',
  'menu.types': 'Loại menu',
  'menu.levels': 'Cấp độ menu',
  'menu.third-level-1': 'Cấp ba 1',
  'menu.third-level-2': 'Cấp ba 2',
  'menu.third-level-3': 'Cấp ba 3',

  /* 04.Dashboards */
  'dashboards.update': 'Cập nhật',
  'dashboards.save': 'Lưu',
  'dashboards.pending-orders': 'Đơn hàng chờ xử lý',
  'dashboards.completed-orders': 'Đơn hàng hoàn thành',
  'dashboards.refund-requests': 'Yêu cầu hoàn tiền',
  'dashboards.new-comments': 'Bình luận mới',
  'dashboards.sales': 'Doanh số',
  'dashboards.orders': 'Đơn hàng',
  'dashboards.refunds': 'Hoàn tiền',
  'dashboards.recent-orders': 'Đơn hàng gần đây',
  'dashboards.product-categories': 'Danh mục sản phẩm',
  'dashboards.cakes': 'Bánh',
  'dashboards.tickets': 'Vé',
  'dashboards.calendar': 'Lịch',
  'dashboards.best-sellers': 'Bán chạy nhất',
  'dashboards.per-session': 'Mỗi phiên',
  'dashboards.profile-status': 'Trạng thái hồ sơ',
  'dashboards.payment-status': 'Trạng thái thanh toán',
  'dashboards.work-progress': 'Tiến độ công việc',
  'dashboards.tasks-completed': 'Nhiệm vụ đã hoàn thành',
  'dashboards.payments-done': 'Thanh toán đã hoàn tất',
  'dashboards.order-stock': 'Đơn hàng - Kho',
  'dashboards.categories': 'Danh mục',
  'dashboards.quick-post': 'Bài đăng nhanh',
  'dashboards.title': 'Tiêu đề',
  'dashboards.content': 'Nội dung',
  'dashboards.ticket-count': 'Số lượng vé',
  'dashboards.commonticketsubmission': 'Các lần gửi vé phổ biến',
  'dashboards.category': 'Danh mục',
  'dashboards.save-and-publish': 'Lưu và xuất bản',
  'dashboards.top-viewed-posts': 'Bài viết xem nhiều nhất',
  'dashboards.posts': 'Bài viết',
  'dashboards.pending-for-publish': 'Chờ xuất bản',
  'dashboards.users': 'Người dùng',
  'dashboards.on-approval-process': 'Đang xử lý phê duyệt',
  'dashboards.alerts': 'Cảnh báo',
  'dashboards.waiting-for-notice': 'Chờ thông báo',
  'dashboards.files': 'Tệp',
  'dashboards.pending-for-print': 'Chờ in',
  'dashboards.logs': 'Nhật ký',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'PHÉP MÀU Ở CHI TIẾT',
  'dashboards.yes-it-is-indeed': 'Đúng vậy, thật vậy!',
  'dashboards.advanced-search': 'Tìm kiếm nâng cao',
  'dashboards.toppings': 'Phần trên',
  'dashboards.type': 'Loại',
  'dashboards.keyword': 'Từ khóa',
  'dashboards.search': 'Tìm kiếm',
  'dashboards.top-rated-items': 'Mục đánh giá cao',

  'dashboards.country': 'Quốc gia',
  'dashboards.webVisitors': 'Khách truy cập web',
  'dashboards.avatarClicks': 'Nhấp vào hình đại diện',
  'dashboards.wordCloud': 'Đám mây từ',
  'dashboards.topic': 'Chủ đề',
  'dashboards.name': 'Tên',
  'dashboards.button': 'Nút',
  'dashboards.visits': 'Lượt truy cập',
  'dashboards.checkAvailability': 'Kiểm tra tình trạng hoặc giá',
  'dashboards.details': 'Chi tiết',
  'dashboards.roomsAvailability': 'Phòng và tình trạng còn chỗ',
  'dashboards.startChat': 'Bắt đầu trò chuyện',
  'dashboards.restaurantsBars': 'Nhà hàng & Quán bar',
  'dashboards.groupBooking': 'Đặt chỗ theo nhóm',
  'dashboards.promotions': 'Khuyến mãi',
  'dashboards.weedingevents': 'Đám cưới & Sự kiện',
  'dashboards.lostsomething': 'Mất một thứ gì đó',
  'dashboards.producttext': 'Văn bản sản phẩm',
  'dashboards.bookingroomnew': 'Đặt phòng mới',
  'dashboards.email': 'Email',
  'dashboards.phone': 'Điện thoại',
  'dashboards.zipcode': 'Mã bưu điện',
  'dashboards.marketingconsent': 'Chấp thuận tiếp thị',
  'dashboards.additionalinfo': 'Thông tin bổ sung',
  'dashboards.viewallcontacts': 'Xem tất cả liên hệ',
  'dashboards.current': 'Hiện tại',
  'dashboards.last7days': '7 ngày qua',
  'dashboards.last30days': '30 ngày qua',
  'dashboards.thisweek': 'Tuần này',
  'dashboards.thismonth': 'Tháng này',
  'dashboards.previousmonth': 'Tháng trước',
  'dashboards.yeartodate': 'Từ đầu năm đến nay',
  'dashboards.lastyear': 'Năm trước',
  'dashboards.all': 'Tất cả',
  'dashboards.standardOccupancy': 'Sức chứa tiêu chuẩn',
  'dashboards.max-occupancy': 'Sức chứa tối đa',
  'dashboards.numberOfThisType': 'Số lượng loại này',
  'dashboards.displayOrder': 'Thứ tự hiển thị',
  'dashboards.provider': 'Nhà cung cấp',
  'dashboards.edit': 'Chỉnh sửa',
  'dashboards.delete': 'Xóa',
  'dashboards.addImages': 'Thêm hình ảnh',
  'dashboards.location_ip': 'Vị trí gần đúng dựa trên địa chỉ IP',
  'dashboards.near': 'Gần',
  'dashboards.referral': 'Người dùng đến trang của bạn qua trang web này',
  'dashboards.calling_party': 'Người gọi',
  'dashboards.called_party': 'Người được gọi',
  'dashboards.lastdial': 'Cuộc gọi cuối',
  'dashboards.imagelink': 'Liên kết hình ảnh',
  'dashboards.browsegallery': 'Duyệt thư viện',
  'dashboards.changelog': 'Nhật ký thay đổi',
  'dashboards.externalresources': 'Tài nguyên bên ngoài',
  'dashboards.webpage': 'Trang web',
  'dashboards.web-pages': 'Trang web',
  'dashboards.published': 'Đã xuất bản',
  'dashboards.adddocument': 'Thêm tài liệu',
  'dashboards.ready-to-publish': 'Sẵn sàng để xuất bản',
  'dashboards.draft': 'Bản nháp',
  'dashboards.order-by': 'Sắp xếp theo',
  'dashboards.add-faq': 'Thêm câu hỏi thường gặp',
  'dashboards.collections': 'Bộ sưu tập',
  'dashboards.items': 'Mặt hàng',
  'dashboards.rooms-availability': 'Phòng & tình trạng phòng',
  'dashboards.events-wedding-venues': 'Sự kiện & địa điểm cưới',
  'dashboards.long-stay-enquiry': 'Yêu cầu lưu trú dài hạn',
  'dashboards.reservation-confirmation-request': 'Yêu cầu xác nhận đặt phòng',
  'dashboards.modify-cancel-booking': 'Sửa đổi hoặc hủy đặt phòng',
  'dashboards.left-something-behind': 'Bỏ quên đồ',
  'dashboards.invoice-copy': 'Bản sao hóa đơn / biên nhận',
  'dashboards.sync': 'Đồng bộ',
  'dashboards.add-web-page': 'Thêm Trang Web',
  'dashboards.sprint-title': 'Gặp gỡ Sprint, tự động hóa đột phá của chúng tôi giúp huấn luyện Mô hình AI nhanh gấp 10 lần.',
  'dashboards.sprint-description': 'Sprint hoạt động cùng bạn — để giải phóng sự sáng tạo, mở khóa năng suất và giảm đáng kể thời gian đào tạo Trợ lý Kỹ thuật số.',
  'dashboards.sprint-feature': 'Tính năng Sprint được thiết kế để đồng bộ kiến thức từ các nguồn bên ngoài, hữu ích cho cả thiết lập ban đầu và cập nhật dữ liệu liên tục. Khi chạy trên hệ thống hoạt động, Sprint sẽ chỉnh sửa Knowledge Hub dựa trên các nguồn bên ngoài bạn đã cấu hình, có thể ảnh hưởng trực tiếp đến hành vi và phản hồi do AI tạo ra. Để được hỗ trợ thiết lập Sprint, vui lòng liên hệ với đội ngũ hỗ trợ của chúng tôi.',
  'dashboards.change-password': 'Thay đổi mật khẩu',
  'dashboards.sign-out': 'Đăng xuất',
  'dashboards.privacy-policy': 'Chính sách bảo mật',
  'dashboards.help-center': 'Trung tâm trợ giúp',
  'dashboards.switch-account': 'Chuyển tài khoản',
  'dashboards.business-settings': 'Cài đặt doanh nghiệp',
  'dashboards.notifications-allowed': 'Cho phép thông báo',
  'dashboards.dark-theme': 'Chủ đề tối',
  'dashboards.online': 'Trực tuyến',
  'dashboards.offline': 'Ngoại tuyến',
  'dashboards.invoice-&-payments': 'Hóa đơn & Thanh toán',
  'dashboards.upgrade‑plan': 'Nâng cấp gói',
  'dashboards.add-room': 'Thêm phòng',
  'dashboards.room-type': 'Loại phòng',
  'dashboards.room-name': 'Tên phòng',
  'dashboards.how-many-guests': 'Bao nhiêu khách có thể ở trong phòng này?',
  'dashboards.number-of-rooms-this-type': 'Số phòng (loại này)',
  'dashboards.number-of-bedrooms': 'Số phòng ngủ',
  'dashboards.number-of-livingrooms': 'Số phòng khách',
  'dashboards.minimum-adults': 'Tối thiểu người lớn',
  'dashboards.maximum-adults': 'Tối đa người lớn',
  'dashboards.maximum-children': 'Tối đa trẻ em',
  'dashboards.maximum-infants': 'Tối đa trẻ sơ sinh',
  'dashboards.extra-beds-allowed': 'Cho phép giường phụ',
  'dashboards.booking-engine-code': 'Mã hệ thống đặt phòng',
  'dashboards.room-size': 'Kích thước phòng',
  'dashboards.balcony-area': 'Diện tích ban công',
  'dashboards.unit': 'Đơn vị',
  'dashboard.whatsapp_message': 'Nhập tin nhắn của bạn tại đây...',
  'dashboard.whatsapp_reply_window': 'Bạn có 24 giờ để trả lời tin nhắn của khách hàng trên WhatsApp Business kể từ thời điểm khách hàng gửi tin nhắn cuối cùng. Nếu bạn phản hồi trong khung chăm sóc khách hàng 24 giờ này, bạn có thể gửi bất kỳ loại tin nhắn nào. Sau khi khung 24 giờ kết thúc, bạn chỉ có thể gửi tin nhắn bằng các Mẫu Tin nhắn đã được phê duyệt trước, và khung 24 giờ sẽ được khởi động lại khi khách hàng phản hồi.',
  'dashboards.square-meters': 'Mét vuông',
  "dashboard.pick_quick_reply": "Chọn trả lời nhanh hoặc nhập tin nhắn của bạn",
  "dashboard.hang_in_there": "Vui lòng đợi trong khi chúng tôi đang cố gắng kết nối!",
  "dashboard.outbound_msg": "Thời điểm gửi tin nhắn đi",
  "dashboard.message_sent": "Tin nhắn của bạn đã được gửi thành công!",
  "dashboard.failed_msg": "Gửi tin nhắn thất bại",
  "dashboard.new_chat_message": "Tin nhắn trò chuyện mới",
  "dashboard.user_msg": "Có tin nhắn từ người dùng trong 24 giờ qua. Bạn có thể trả lời bằng bất kỳ tin nhắn nào. Bạn vẫn muốn gửi tin nhắn mẫu này hay trả lời bằng tin nhắn khác?",
  "dashboard.us_number": "Tin nhắn WhatsApp Business không được gửi đến các số tại Hoa Kỳ vì Meta đã tạm dừng tất cả các tin nhắn tiếp thị đến các số tại Hoa Kỳ vào ngày 1 tháng 4 năm 2025.",
  "dashboard.error_msg": "Vui lòng điền đầy đủ và chính xác tất cả các trình giữ chỗ.",


  'web-widget.title': 'Menu Tiện ích Web cho Chatbot của Trang web',

  /*Home page*/
  'dashboards.quickstartwithai': 'Bắt đầu nhanh với AI',
  'dashboards.fastestpathtoautomation': 'Bạn đang trên con đường nhanh nhất tới tự động hóa với các công cụ AI',
  'dashboards.insightsthatempower': 'Những hiểu biết truyền sức mạnh',
  'dashboards.trainchatbot': 'Đào tạo chatbot',
  'dashboards.automatewithforms': 'Tự động hóa bằng biểu mẫu',
  'dashboards.inroomdigitalcompendium': 'Tổng hợp kỹ thuật số trong phòng',
  'dashboards.support': 'Hỗ trợ',
  'dashboards.helpcenter': 'Trung tâm trợ giúp',
  'dashboards.searchfaqintegrations': 'Tìm bài viết về các câu hỏi thường gặp, tích hợp và nhiều hơn nữa.',
  'dashboards.asklivechat': 'Đặt câu hỏi với đội của chúng tôi trong Live Chat',
  'dashboards.inroomqrcode': 'Mã QR trong phòng để xem thông tin về cơ sở và vị trí',
  'dashboards.customizewebwidget': 'Tùy chỉnh và thêm Widget web vào trang web của bạn với Chatbot AI tích hợp',
  'dashboards.createcustomforms': 'Tạo các biểu mẫu tùy chỉnh và nhận thông báo khi khách gửi biểu mẫu',
  'dashboards.trainchatbotproperty': 'Huấn luyện Chatbot với thông tin về cơ sở như giờ check‑in, hoạt động v.v.',
  'dashboards.chatbotinsights': 'Xem cách Chatbot của bạn tương tác với khách và có được thông tin chi tiết về các chỉ số như lượt truy cập web, câu hỏi thường gặp và nhiều hơn nữa.',
  'dashboards.addaichatbottoyourwebsite': 'Thêm Chatbot AI vào trang web của bạn',

  /* Email Stats */
  'dashboards.thread-summary-title': 'Tóm tắt luồng',
  'dashboards.thread-summary-subtitle': 'Tóm tắt email tạo bởi AI',
  'dashboards.ai-replies-title': 'Phản hồi AI',
  'dashboards.ai-replies-subtitle': 'Phản hồi được tạo bởi AI',
  'dashboards.total-thread-summary-title': 'Tổng tóm tắt luồng đã tạo',
  'dashboards.total-ai-replies-title': 'Tổng phản hồi AI đã tạo',
  'dashboards.total-draft-copied': 'Bản nháp được sao chép bởi người dùng',
  'dashboards.urgency': 'Mức khẩn cấp',
  'dashboards.sentiment': 'Cảm xúc',
  'dashboards.common-email-reasons': 'Lý do email phổ biến',
  'dashboards.topics-in-emails': 'Chủ đề trong email',
  'dashboards.email-assistant-usage': 'Sử dụng Trợ lý Email AI',


  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Phân tích',
  'pages.title.ari': 'Tình trạng và Giá cả',
  'pages.title.conversations': 'Cuộc trò chuyện',
  'pages.title.bookings': 'Đặt chỗ và Đặt trước',
  'pages.title.tickets': 'Khách hàng tiềm năng và Vé',
  'pages.title.propinfo': 'Phản hồi',
  'pages.title.discounts': 'Giảm giá và Khuyến mãi',
  'pages.title.finance': 'Tài chính',
  'pages.title.integration': 'Tích hợp',
  'pages.title.admin': 'Quản trị',
  'pages.add-new': 'THÊM MỚI',
  'pages.add-new-modal-title': 'Thêm mục mới',
  'pages.display-options': 'Tùy chọn hiển thị',
  'pages.orderby': 'Sắp xếp theo : ',
  'pages.product-name': 'Tên sản phẩm',
  'pages.category': 'Danh mục',
  'pages.description': 'Mô tả',
  'pages.status': 'Trạng thái',
  'pages.cancel': 'Hủy',
  'pages.submit': 'Gửi',
  'pages.delete': 'Xóa',
  'pages.another-action': 'Hành động khác',
  'pages.actions': 'HÀNH ĐỘNG',
  'pages.header': 'Tiêu đề',
  'pages.details': 'CHI TIẾT',
  'pages.orders': 'ĐƠN HÀNG',
  'pages.rating': 'Đánh giá',
  'pages.price': 'Giá',
  'pages.ingredients': 'Thành phần',
  'pages.is-vegan': 'Có phải thuần chay',
  'pages.order-status': 'Trạng thái đơn hàng',
  'pages.bake-progress': 'Tiến trình nướng',
  'pages.popularity': 'Độ phổ biến',
  'pages.comments': 'Bình luận',
  'pages.error-title': 'Ôi không... có lỗi xảy ra!',
  'pages.error-code': 'Mã lỗi',
  'pages.go-back-home': 'QUAY VỀ TRANG CHỦ',
  'pages.mailing-info': 'Mẫu thư điện tử sử dụng kiểu dáng nội tuyến và bố cục bảng để hiển thị tốt trên nhiều nhà cung cấp dịch vụ. Để cải thiện khả năng sử dụng, chúng tôi bao gồm nó dưới dạng HTML thông thường với dangerouslySetInnerHTML.',
  'pages.invoice-info': 'Mẫu hóa đơn có phiên bản kiểu nội tuyến để sử dụng bên ngoài dự án cũng như phiên bản React.',
  'pages.react-version': 'Phiên bản React',
  'pages.inline-version': 'Phiên bản HTML kiểu nội tuyến',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'tin nhắn',
  'chat.contacts': 'Liên lạc',
  'chat.saysomething': 'Nói gì đó đi..',

  /* 06.02.Survey */
  'survey.delete': 'Xóa',
  'survey.edit': 'Chỉnh sửa',
  'survey.add-new': 'THÊM MỚI',
  'survey.add-new-title': 'Thêm khảo sát mới',
  'survey.title': 'Tiêu đề',
  'survey.category': 'Danh mục',
  'survey.label': 'Nhãn',
  'survey.status': 'Trạng thái',
  'survey.cancel': 'Hủy',
  'survey.submit': 'Gửi',
  'survey.another-action': 'Hành động khác',
  'survey.display-options': 'Tùy chọn hiển thị',
  'survey.orderby': 'Sắp xếp theo : ',
  'survey.all-surveys': 'Tất cả khảo sát',
  'survey.completed-surveys': 'Khảo sát đã hoàn thành',
  'survey.categories': 'Danh mục',
  'survey.active-surveys': 'Khảo sát đang hoạt động',
  'survey.labels': 'Nhãn',

  /* 06.03.Todo */
  'todo.add-new': 'THÊM MỚI',
  'todo.add-new-title': 'Thêm công việc mới',
  'todo.title': 'Tiêu đề',
  'todo.detail': 'Chi tiết',
  'todo.category': 'Danh mục',
  'todo.label': 'Nhãn',
  'todo.status': 'Trạng thái',
  'todo.cancel': 'Hủy',
  'todo.submit': 'Gửi',
  'todo.action': 'Hành động',
  'todo.another-action': 'Hành động khác',
  'todo.display-options': 'Tùy chọn hiển thị',
  'todo.orderby': 'Sắp xếp theo : ',
  'todo.all-tasks': 'Tất cả công việc',
  'todo.pending-tasks': 'Công việc đang chờ',
  'todo.completed-tasks': 'Công việc đã hoàn thành',
  'todo.categories': 'Danh mục',
  'todo.labels': 'Nhãn',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Cảnh báo bo tròn',
  'alert.react-notifications': 'Thông báo React',
  'alert.outline': 'Viền ngoài',
  'alert.primary': 'Chính',
  'alert.secondary': 'Phụ',
  'alert.info': 'Thông tin',
  'alert.success': 'Thành công',
  'alert.warning': 'Cảnh báo',
  'alert.error': 'Lỗi',
  'alert.filled': 'Đầy màu',
  'alert.primary-text': 'Đây là cảnh báo chính — hãy kiểm tra!',
  'alert.secondary-text': 'Đây là cảnh báo phụ — hãy kiểm tra!',
  'alert.success-text': 'Đây là cảnh báo thành công — hãy kiểm tra!',
  'alert.danger-text': 'Đây là cảnh báo nguy hiểm — hãy kiểm tra!',
  'alert.warning-text': 'Đây là cảnh báo — hãy kiểm tra!',
  'alert.info-text': 'Đây là cảnh báo thông tin — hãy kiểm tra!',
  'alert.light-text': 'Đây là cảnh báo nhẹ — hãy kiểm tra!',
  'alert.dark-text': 'Đây là cảnh báo tối — hãy kiểm tra!',
  'alert.default': 'Cảnh báo mặc định',
  'alert.dismissing': 'Cảnh báo có thể đóng',
  'alert.dismissing-text': 'Chú ý! Bạn nên kiểm tra lại một số trường dưới đây.',
  'alert.dismissing-without-animate-text': 'Tôi là cảnh báo và có thể đóng mà không cần hiệu ứng!',

  /* 07.02.Badges */
  'badge.sizes': 'Kích cỡ',
  'badge.colors': 'Màu sắc',
  'badge.outline': 'Viền ngoài',
  'badge.links': 'Liên kết',
  'badge.counter-badges': 'Huy hiệu đếm',
  'badge.bootstrap-default': 'Bootstrap Mặc định',
  'badge.primary': 'Chính',
  'badge.secondary': 'Phụ',
  'badge.success': 'Thành công',
  'badge.danger': 'Nguy hiểm',
  'badge.warning': 'Cảnh báo',
  'badge.info': 'Thông tin',
  'badge.light': 'Nhẹ',
  'badge.dark': 'Tối',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Mặc định',
  'button.colors': 'Màu sắc',
  'button.rounded': 'Bo tròn',
  'button.outline': 'Viền ngoài',
  'button.states': 'Trạng thái',
  'button.sizes': 'Kích cỡ',
  'button.button-groups': 'Nhóm nút',
  'button.large-button': 'Nút lớn',
  'button.small-button': 'Nút nhỏ',
  'button.extra-small-button': 'Nút rất nhỏ',
  'button.block-button': 'Nút dạng khối',
  'button.active': 'Hoạt động',
  'button.disabled': 'Vô hiệu hóa',
  'button.basic': 'Cơ bản',
  'button.toolbar': 'Thanh công cụ',
  'button.nesting': 'Lồng nhau',
  'button.vertical-variation': 'Biến thể dọc',
  'button.checkbox-radio-button': 'Hộp kiểm và nút radio',
  'button.checkbox': 'Hộp kiểm',
  'button.radio': 'Nút radio',
  'button.radio-button': 'Nút radio',
  'button.primary': 'Chính',
  'button.secondary': 'Phụ',
  'button.success': 'Thành công',
  'button.danger': 'Nguy hiểm',
  'button.warning': 'Cảnh báo',
  'button.info': 'Thông tin',
  'button.light': 'Nhẹ',
  'button.dark': 'Tối',
  'button.states-text': 'Nút này hiển thị vòng quay trong 2 giây và biểu tượng lỗi trong 3 giây trước khi trở về trạng thái bình thường. Trạng thái này có thể kích hoạt bằng cách thêm và xóa các lớp.',
  'button.click-here': 'Nhấn vào đây',
  'button.states-text-alternate': 'Nút này hiển thị vòng quay trong 2 giây và biểu tượng lỗi trong 3 giây trước khi trở về trạng thái bình thường. Trạng thái này có thể kích hoạt bằng cách thêm và xóa các lớp.',
  'button.primary-link': 'Liên kết chính',
  'button.link': 'Liên kết',
  'button.primary-button': 'Nút chính',
  'button.button': 'Nút',
  'button.left': 'Trái',
  'button.middle': 'Giữa',
  'button.right': 'Phải',
  'button.dropdown': 'Danh sách thả',
  'button.dropdown-link': 'Liên kết danh sách thả',

  /* 07.04.Cards */
  'cards.icon-card': 'Thẻ biểu tượng',
  'cards.image-card': 'Thẻ hình ảnh',
  'cards.image-overlay-card': 'Thẻ phủ hình ảnh',
  'cards.image-card-list': 'Danh sách thẻ hình ảnh',
  'cards.tab-card': 'Thẻ tab',
  'cards.user-card': 'Thẻ người dùng',

  /* 07.05.Carousel */
  'carousel.basic': 'Băng chuyền cơ bản',
  'carousel.single': 'Băng chuyền đơn',
  'carousel.without-controls': 'Băng chuyền không điều khiển',

  /* 07.06.Charts */
  'charts.line': 'Biểu đồ đường',
  'charts.polar': 'Biểu đồ cực',
  'charts.area': 'Biểu đồ vùng',
  'charts.scatter': 'Biểu đồ phân tán',
  'charts.bar': 'Biểu đồ cột',
  'charts.radar': 'Biểu đồ radar',
  'charts.pie': 'Biểu đồ tròn',
  'charts.doughnut': 'Biểu đồ vòng',
  'charts.shadow': 'Bóng',
  'charts.no-shadow': 'Không bóng',

  /* 07.07.Collapse */
  'collapse.basic': 'Cơ bản',
  'collapse.toggle': 'Chuyển đổi',
  'collapse.accordion': 'Bảng gấp',
  'collapse.controlled': 'Có điều khiển',
  'collapse.uncontrolled': 'Không điều khiển',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Cơ bản',
  'dropdowns.controlled': 'Có điều khiển',
  'dropdowns.uncontrolled': 'Không điều khiển',
  'dropdowns.dropdown': 'Menu thả xuống',
  'dropdowns.header': 'Tiêu đề',
  'dropdowns.action': 'Hành động',
  'dropdowns.another-action': 'Hành động khác',
  'dropdowns.right': 'Phải',
  'dropdowns.left': 'Trái',
  'dropdowns.drop-directions': 'Hướng thả',
  'dropdowns.dropright': 'Thả bên phải',
  'dropdowns.dropleft': 'Thả bên trái',
  'dropdowns.small-button': 'Nút nhỏ',
  'dropdowns.large-button': 'Nút lớn',
  'dropdowns.sizing': 'Kích thước',
  'dropdowns.split-button': 'Nút tách',
  'dropdowns.dropup': 'Thả lên trên',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Chuẩn',
  'editors.quill-bubble': 'Quill Bong bóng',

  /* 07.10.Forms */
  'forms.basic': 'Cơ bản',
  'forms.email': 'Email',
  'forms.email-muted': 'Chúng tôi sẽ không chia sẻ email của bạn với bất kỳ ai khác.',
  'forms.password': 'Mật khẩu',
  'forms.submit': 'Gửi',
  'forms.horizontal': 'Nằm ngang',
  'forms.radios': 'Radio',
  'forms.first-radio': 'Radio đầu tiên',
  'forms.second-radio': 'Radio thứ hai',
  'forms.third-radio-disabled': 'Radio thứ ba bị vô hiệu hóa',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Đăng nhập',
  'forms.top-labels-over-line': 'Nhãn trên đường kẻ',
  'forms.tags': 'Thẻ',
  'forms.date': 'Ngày',
  'forms.state': 'Tỉnh/Thành phố',
  'forms.top-labels-in-input': 'Nhãn trên ô nhập liệu',
  'forms.email-u': 'EMAIL',
  'forms.password-u': 'MẬT KHẨU',
  'forms.tags-u': 'THẺ',
  'forms.date-u': 'NGÀY',
  'forms.state-u': 'TỈNH/TP',
  'forms.grid': 'Lưới biểu mẫu',
  'forms.address': 'Địa chỉ',
  'forms.address2': 'Địa chỉ 2',
  'forms.city': 'Thành phố',
  'forms.city-message': 'Vui lòng chọn thành phố!',
  'forms.state-message': 'Vui lòng chọn tỉnh/thành phố!',
  'forms.zip': 'Mã bưu điện',
  'forms.signup': 'Đăng ký',
  'forms.inline': 'Nối dòng',
  'forms.validation-availity': 'Xác thực Availity Reactstrap',
  'forms.validation-formik': 'Xác thực Formik',
  'forms.default': 'Mặc định',
  'forms.firstname': 'Tên',
  'forms.firstname-message': 'Vui lòng nhập tên của bạn!',
  'forms.lastname': 'Họ',
  'forms.lastname-message': 'Vui lòng nhập họ của bạn!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Đầu vào tùy chỉnh',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radio',
  'form-components.inline': 'Nối dòng',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'Chọn một tỉnh',
  'form-components.state-multiple': 'Chọn nhiều tỉnh',
  'form-components.react-autosuggest': 'React Gợi ý tự động',
  'form-components.date-picker': 'Chọn ngày',
  'form-components.date': 'Ngày',
  'form-components.date-range': 'Khoảng ngày',
  'form-components.date-with-time': 'Ngày và giờ',
  'form-components.embedded': 'Nhúng',
  'form-components.dropzone': 'Khu vực thả tệp',
  'form-components.drop-files-here': 'Thả tệp vào đây',
  'form-components.tags': 'Thẻ',
  'form-components.switch': 'Công tắc',
  'form-components.primary': 'Chính',
  'form-components.secondary': 'Phụ',
  'form-components.primary-inverse': 'Chính đảo',
  'form-components.secondary-inverse': 'Phụ đảo',
  'form-components.slider': 'Thanh trượt',
  'form-components.double-slider': 'Thanh trượt đôi',
  'form-components.single-slider': 'Thanh trượt đơn',
  'form-components.rating': 'Đánh giá',
  'form-components.interactive': 'Tương tác',
  'form-components.readonly': 'Chỉ đọc',
  'form-components.type-a-cake': 'Nhập tên bánh',
  'form-components.start': 'Bắt đầu',
  'form-components.end': 'Kết thúc',
  'form-components.tables': 'Bảng',

  /* 07.12.Icons */
  'icons.simplelineicons': 'Biểu tượng Simple Line',
  'icons.iconsmind': 'Biểu tượng Iconsmind',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Cơ bản',
  'input-groups.sizing': 'Kích thước',
  'input-groups.small': 'Nhỏ',
  'input-groups.default': 'Mặc định',
  'input-groups.large': 'Lớn',
  'input-groups.checkboxes-and-radios': 'Checkbox và radio',
  'input-groups.multiple-inputs': 'Nhiều đầu vào',
  'input-groups.first-and-last-name': 'Họ và tên',
  'input-groups.multiple-addons': 'Nhiều tiện ích',
  'input-groups.button-addons': 'Tiện ích nút',
  'input-groups.button': 'Nút',
  'input-groups.buttons-with-dropdowns': 'Nút với menu thả xuống',
  'input-groups.dropdown': 'Menu thả xuống',
  'input-groups.header': 'Tiêu đề',
  'input-groups.action': 'Hành động',
  'input-groups.another-action': 'Hành động khác',
  'input-groups.custom-select': 'Chọn tùy chỉnh',
  'input-groups.options': 'Tùy chọn',
  'input-groups.choose': 'Chọn...',
  'input-groups.custom-file-input': 'Nhập tệp tùy chỉnh',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Xin chào, thế giới!',
  'jumbotron.lead': 'Đây là một đơn vị anh hùng đơn giản, một thành phần kiểu jumbotron đơn giản để thu hút sự chú ý đặc biệt đến nội dung hoặc thông tin nổi bật.',
  'jumbotron.lead-detail': 'Nó sử dụng các lớp tiện ích cho kiểu chữ và khoảng cách để tạo khoảng cách cho nội dung trong container lớn hơn.',
  'jumbotron.learn-more': 'Tìm hiểu thêm',

  /* 07.15.Modal */
  'modal.basic': 'Cơ bản',
  'modal.modal-title': 'Tiêu đề cửa sổ',
  'modal.launch-demo-modal': 'Khởi chạy cửa sổ thử nghiệm',
  'modal.scrolling-long-content': 'Nội dung dài có thể cuộn',
  'modal.backdrop': 'Phông nền',
  'modal.backdrop-value': 'Giá trị phông nền',
  'modal.right-modal': 'Cửa sổ bên phải',
  'modal.launch-right-modal': 'Khởi chạy cửa sổ bên phải',
  'modal.nested-modal': 'Cửa sổ lồng nhau',
  'modal.size': 'Kích thước',
  'modal.launch-large-modal': 'Khởi chạy cửa sổ lớn',
  'modal.launch-small-modal': 'Khởi chạy cửa sổ nhỏ',

  /* 07.16.Navigation */
  'nav.basic': 'Điều hướng cơ bản',
  'nav.active': 'Hoạt động',
  'nav.disabled': 'Bị vô hiệu hóa',
  'nav.disabled-link': 'Liên kết bị vô hiệu hóa',
  'nav.link': 'Liên kết',
  'nav.longer-link': 'Liên kết dài hơn',
  'nav.another-link': 'Liên kết khác',
  'nav.right': 'Phải',
  'nav.dropdown': 'Menu thả xuống',
  'nav.header': 'Tiêu đề',
  'nav.action': 'Hành động',
  'nav.another-action': 'Hành động khác',
  'nav.horizontal-alignment': 'Căn chỉnh ngang',
  'nav.vertical-alignment': 'Căn chỉnh dọc',
  'nav.pills': 'Điều hướng dạng viên',
  'nav.fill-justify': 'Điều hướng căn đều',
  'nav.pills-dropdowns': 'Điều hướng dạng viên với menu thả xuống',
  'nav.pagination-basic': 'Phân trang cơ bản',
  'nav.pagination-sizing': 'Kích thước phân trang',
  'nav.large': 'Lớn',
  'nav.small': 'Nhỏ',
  'nav.center': 'Giữa',
  'nav.pagination-alignment': 'Căn chỉnh phân trang',
  'nav.breadcrumb-basic': 'Đường dẫn cơ bản',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sắp xếp cột',
  'sortable.basic': 'Cơ bản',
  'sortable.handles': 'Tay cầm',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bảng Bootstrap',
  'table.bootstrap-basic': 'Bảng cơ bản',
  'table.bootstrap-striped': 'Hàng có sọc',
  'table.bootstrap-bordered': 'Bảng có viền',
  'table.bootstrap-borderless': 'Bảng không viền',
  'table.bootstrap-hoverable': 'Hàng có hiệu ứng hover',
  'table.bootstrap-responsive': 'Bảng đáp ứng',
  'table.react-tables': 'Bảng React',
  'table.react-pagination': 'Phân trang',
  'table.react-scrollable': 'Cuộn được',
  'table.react-advanced': 'Bộ lọc, Độ dài và Nhảy',


  /* Property Info */
  "property-info.allcustomers": 'Tất cả khách hàng',
  'property-info.external-sources': 'Nguồn Ngoài',
  'property-info.faq': 'Câu hỏi thường gặp',
  'property-info.documents': 'Tài liệu',
  'property-info.publish-ai': 'Xuất bản AI',
  'property-info.pre-built-templates': 'Mẫu xây dựng sẵn',
  'property-info.room-types': 'Loại phòng',

  'property-info.about-property': 'về tài sản',
  'property-info.about-properties': 'Giới thiệu về Thuộc tính',
  'property-info.facilities-services': 'dịch vụ cơ sở vật chất',
  'property-info.property-facilities': 'cơ sở tài sản',
  'property-info.room-amenities': 'tiện nghi phòng',
  'property-info.property-contact': 'liên hệ tài sản',
  'property-info.property-activities': 'hoạt động tài sản',
  'property-info.property-location': 'vị trí tài sản',
  'property-info.about-rooms': 'về phòng',
  'property-info.about-sites': 'Giới thiệu về các trang web',
  'property-info.special-emergencies': 'Các trường hợp khẩn cấp',
  'property-info.gallery': 'Bộ sưu tập',
  'property-info.policies': 'Chính sách',
  'property-info.nearby': 'Lân cận',
  'property-info.transport': 'Vận chuyển',
  'property-info.location': 'Vị trí',
  'property-info.about-rhproperty': 'Giới thiệu về Trang chủ Hưu trí',
  'property-info.related-topics': 'Chủ đề liên quan',
  'property-info.assistant-options': 'Tùy chọn Trợ lý',
  'property-info.restaurant-assistant-information': 'Thông tin nhà hàng',
  'property-info.restaurant-assistant-options': 'Tin nhắn chào mừng',
  'property-info.channel-messages': 'Tin nhắn kênh',
  'property-info.icon.gallery': 'Thư viện biểu tượng',
  'property-info.copilot': 'Phi công phụ',
  'property-info.sprint': 'tăng tốc',
  'property-info.home-information': 'Trang chủ Thông tin',
  'property-info.loction': 'Vị trí',
  'property-info.rooms-and-images': 'Phòng & Hình ảnh',
  'property-info.trainig-data': 'Dữ liệu đào tạo',
  'property-info.flows': 'Chảy',
  'property-info.add-your-own': 'Thêm của riêng bạn',
  'property-info-utility-miscellaneous': 'Điều khoản khác',
  'property-info-utility-payment': 'Thanh toán',
  'property-info-utility-broadband': 'Băng thông rộng',
  'property-info-utility-emergency': 'Khẩn cấp',
  'property-info-utility-mobile': 'Điện thoại di động',
  'property-info-utility-moving': 'Di chuyển',
  'property-info.publishMonitor': 'Xuất bản & Giám sát',
  'property-info.webWidget': 'Tiện ích web',
  'property-info.media': 'Phương tiện',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Xếp hạng các gói',
  'rate-promo.rate-plan-addons': 'Tiện ích bổ sung',
  'rate-promo.rate-plan-promos': 'Quảng cáo',

  'title.property-information': 'thông tin tài sản',

  'property.message': 'Thông điệp',
  'property.example': 'Thí dụ',
  'property.link': 'Liên kết',
  'property.image-carousel': 'Băng chuyền hình ảnh',
  'property.Title': 'Tiêu đề',
  'property.SubTitle': 'Phụ đề',

  'property.add-invoke-api': 'Gọi API',
  'property.add-message-button': 'Thêm tin nhắn',
  'property.add-img-button': 'Thêm hình ảnh',
  'property.add-link-button': 'Thêm liên kết',
  'property.add-herocard-button': 'Thêm thẻ anh hùng',
  'property.add-api-button': 'Thêm các nút',

  'dashboards.usage-by-email-address': 'Sử dụng theo địa chỉ email',

  'menu.settings': 'Cài đặt',
  'menu.workflows': 'Luồng công việc',
  'menu.product_services': 'Sản phẩm & Dịch vụ',
  'menu.product_recommander': 'Trình Đề xuất Sản phẩm',
  'menu.digital_guide_book': 'Sách hướng dẫn kỹ thuật số',
  'menu.welcome_message': 'Tin chào mừng',
  'menu.about-property': 'Về tài sản',
  'menu.property-facilities': 'Tiện nghi tài sản',
  'menu.room-amenities': 'Tiện nghi phòng',
  'menu.property-contact': 'Liên hệ tài sản',
  'menu.about-rooms': 'Phòng',
  'menu.special-emergencies': 'Khẩn cấp',
  'menu.show-filter': 'Bộ lọc',
  'menu.new': 'Mới',
  'menu.channel': 'Kênh',
  'menu.application': 'Ứng dụng',
  'menu.content-manager': 'Quản lý Nội dung',
  'menu.events-calendar': 'Lịch sự kiện',
  'menu.appearance-settings': 'Giao diện & Cài đặt',

  'dashboards.send': 'Gửi',
  'dashboards.hello': 'Xin chào',
  'dashboards.notificationsAllowed': 'Cho phép thông báo',
  'dashboards.allowNotifications': 'Cho phép thông báo',
  'dashboards.views': 'Lượt xem',
  'dashboards.bookingURL': 'URL đặt chỗ',
  'dashboards.searchTags': 'Thẻ tìm kiếm',
  'dashboards.searchCategoryTags': 'Thẻ danh mục tìm kiếm',
  'dashboards.bedroom': 'Phòng ngủ',
  'dashboards.addBedroom': 'Thêm phòng ngủ',
  'dashboards.frequency': 'Tần suất',
  'dashboards.includeSubpages': 'Bao gồm các trang phụ',
  'dashboards.enableFaqs': 'Kích hoạt FAQs',
  'dashboards.faqsDescription': 'Kích hoạt FAQs cho phép bạn nhập câu hỏi trong khi hệ thống trích xuất các câu trả lời tương ứng từ nội dung trang web để tạo FAQs hoàn chỉnh',
  'dashboards.faq': 'Câu hỏi thường gặp',
  'dashboards.deleteDocument': 'Xóa tài liệu',
  'dashboards.confirmDelete': 'Bạn có chắc muốn xóa không?',
  'dashboards.addItem': 'Thêm mục',
  'dashboards.addFirstWebPage': 'Thêm trang web đầu tiên của bạn',

  'dashboards.popular-compendium': 'Mục trình đơn phổ biến trong tuyển tập',
  'dashboards.wordcloudofcompendium': 'Đám mây từ cho mục trình đơn tuyển tập',
  'dashboards.wordcloudonthings': 'Đám mây từ về những gì khách truy cập website đang hỏi & mục trình đơn',
  'dashboards.common-asked': 'Các câu hỏi thường gặp',
  'dashboards.website-visitor-asking':
    'Những điều khách truy cập trang web hỏi về',
  'dashboards.visit-country': 'Truy cập trang web theo quốc gia',
  'dashboards.visit-traffic': 'Quốc gia của lưu lượng truy cập trang web',
  'dashboards.rooms-product': 'Phòng & Sản phẩm',
  'dashboards.popular-room-product': 'Phòng và sản phẩm phổ biến',

  'dashboards.messenger-stats': 'Mục menu phổ biến',
  'dashboards.messenger-stats-topic-view':
    'Số liệu thống kê về lượt xem mục menu',
  'dashboards.messenger-stats-visits': 'Lượt xem mục menu',
  'dashboards.opening-menu-items':
    'Số lượng khách truy cập trang web mở các mục menu',
  'dashboards.tickets-by-category': 'Vé theo danh mục',
  'dashboards.download': 'Tải xuống',
  'dashboards.number-totalavatarclick': 'Tổng số nhấp chuột vào hình đại diện',
  'dashboards.subscribe-to-reports': 'Đăng ký báo cáo',
  'dashboards.clicks': 'Số nhấp chuột',
  'dashboards.leads': 'khách hàng tiềm năng',
  'dashboards.hours': 'Giờ',
  'dashboards.minutes': 'Phút',
  'dashboards.connect': 'Kết nối',
  'dashboards.ai-chatbot': 'Chatbot AI',
  'dashboards.compendium': 'Bản tóm tắt',
  'dashboards.compendium-digital-usage': 'Cách sử dụng bản tóm tắt kỹ thuật số',
  'dashboards.compendium-unique-visits': 'Quét/nhấp vào mã QR',
  'dashboards.compendium-opening-menu-items': 'Số món trong menu đã xem',
  'dashboards.compendium-total-digital-clicks':
    'Tổng số lượt xem mục menu',
  'dashboards.compendium-total-qr-code': 'Tổng số lần quét/nhấp vào mã QR',
  'dashboards.compendium-avg-menu-items': 'Lượt xem mục menu trung bình mỗi lần quét',

  'property.delete': 'Xóa bỏ',
  'menu.userroles': 'Người dùng & Vai trò',
  'menu.members': 'Thành viên',
  'menu.guest-pass': 'Thẻ Khách',
  'menu.ratebookings': 'Giá & Đặt chỗ',
  'dashboards.engagement-time': 'Thời gian tương tác với Trợ lý kỹ thuật số',
  'dashboards.conversations-minutes':
    'Tổng số phút & qua đêm (7 giờ tối đến 7 giờ sáng) Phút trò chuyện',
  'dashboards.visitor-questions': 'Câu hỏi của khách',
  'dashboards.recent-queries': 'Truy vấn gần đây',
  'dashboards.visitor-saying':
    'Khách truy cập của bạn đang nói gì với Trợ lý kỹ thuật số',
  'dashboards.contacts-prechatform-leavemessage':
    'Danh bạ được lưu trữ từ Biểu mẫu trò chuyện trước & Để lại tin nhắn',
  'menu.dashboards': 'Thông tin chi tiết',
  'menu.ari': 'Tính khả dụng & giá cả',
  'menu.conversations': 'Cuộc trò chuyện',
  'menu.conversations.unified-inbox': 'Hộp thư đến hợp nhất',
  'menu.conversations.active': 'Tích cực Trò chuyện',
  'menu.conversations.archives': 'lưu trữ',
  'menu.conversations.missed-responses': 'Phản hồi bị bỏ lỡ',
  'menu.conversations.ticket': 'Vé',
  'menu.conversations.reply-templates': 'Mẫu trả lời',
  'menu.bookings': 'Đặt chỗ & đặt chỗ',
  'menu.tickets': 'Khách hàng tiềm năng & vé',
  'menu.propinfo': 'Trung tâm tri thức',
  'menu.rate-promos': 'Giá & Khuyến mại',
  'menu.finance': 'Tài chánh',
  'menu.integration': 'Liên kết',
  'menu.admin': 'Quản trị viên & Bảo mật',
  'menu.favourites': 'yêu thích',
  'menu.recommender': 'Luồng hội thoại',
  'menu.assistant-setup': 'Thiết lập trợ lý',
  'menu.admin-insights': 'Thông tin chi tiết của quản trị viên',
  'menu.super-admin': 'Siêu quản trị viên',
  'menu.groups': 'Nhóm',
  'menu.properties': 'Của cải',
  'menu.service-provider': 'Nhà cung cấp dịch vụ',
  'menu.spaces': 'Không gian',
  'menu.availability': 'Tính sẵn có',
  'menu.help': 'Trợ giúp',
  'menu.myAccounts': 'Tài khoản của tôi',
  'menu.guest-messaging': 'Nhắn tin khách',
  'guest-messaging.settings': 'Cài đặt',
  'guest-messaging.outreach-setup': 'Thiết lập tiếp cận',
  'guest-messaging.reservations': 'Đặt phòng',
  'guest-messaging.insights_logs': 'Thông tin chuyên sâu và nhật ký',
  'guest-messaging.reservation-source': 'Nguồn dữ liệu đặt phòng',
  'guest-messaging.communication-channels': 'Kênh liên lạc',
  'guest-messaging.templates': 'Mẫu',
  'guest-messaging.link': 'Liên kết',
  'guest-messaging.business-profile': 'Hồ sơ doanh nghiệp',


  'dashboards.space-booking': 'Đặt chỗ',
  'dashboards.gift-voucher': 'Phiếu quà tặng',
  'dashboards.chatbots': 'Chatbot',
  'dashboards.form': 'Từ',
  'dashboards.to': 'ĐẾN',
  'dashboards.active-groups': 'Nhóm hoạt động',
  'dashboards.active-properties': 'Thuộc tính hoạt động',
  'dashboards.live-properties': 'Thuộc tính trực tiếp',
  'dashboards.properties-going':
    'Các thuộc tính sẽ hoạt động theo phạm vi ngày',
  'dashboards.start-date': 'Ngày bắt đầu',
  'dashboards.end-date': 'Ngày kết thúc',

  'dashboards.website-visits': 'Lượt truy cập trang web',
  'dashboards.unique-visitors': 'Số lượng khách truy cập',
  'dashboards.last-week': 'Tuần trước',
  'dashboards.this-week': 'Tuần này',
  'dashboards.this-month': 'Tháng này',
  'dashboards.previous-month': 'Tháng trước',
  'dashboards.yeartodate': 'Từ năm đến nay',
  'dashboards.lastyear': 'Năm ngoái',
  'dashboards.last-7-days': '7 ngày qua',
  'dashboards.last-30-days': '30 ngày trước',
  'dashboards.last-60-days': '60 ngày trước',
  'dashboards.last-90-days': '90 ngày trước',
  'dashboards.conversion-rates': 'Tỷ lệ chuyển đổi',
  'dashboards.digital-assistant-engagement': 'Tương tác với Trợ lý kỹ thuật số',
  'dashboards.total-overnight-conversations':
    'Cuộc trò chuyện Tổng thể & Qua đêm (7 giờ tối đến 7 giờ sáng)',
  'dashboards.percentage-accuracy': 'Phạm vi kiến thức',
  'dashboards.percentage-conversion':
    'Lưu lượng truy cập trang web để chuyển đổi trò chuyện',
  'dashboards.percentage-avatarclick':
    'Lưu lượng truy cập trang web đến số lần nhấp chuột vào Avatar',
  'dashboards.percentage-negativefeedback':
    'Phản hồi tiêu cực tính theo % số lần nhấp vào Hình đại diện',
  'dashboards.percentage-amenties': 'Truy vấn tiện ích',
  'dashboards.percentage-booking': 'Yêu cầu đặt phòng',
  'dashboards.percentage-webchats': 'Trò chuyện trên trang web',
  'dashboards.percentage-facebookchat': 'Trò chuyện trên Facebook',
  //'dashboards.number-webchattime': 'Tổng thời gian trò chuyện trên web',

  'dashboards.number-webchattime': 'Tổng thời gian trò chuyện',
  'dashboards.number-totalconversation': 'Tổng số cuộc trò chuyện',
  'dashboards.number-websiteconversation': 'Cuộc trò chuyện trên trang web',
  'dashboards.number-facebookconversation': 'Cuộc trò chuyện trên Facebook',
  'dashboards.number-estimatedtimesaving': 'Tiết kiệm thời gian ước tính',
  'dashboards.number-googlemapsconversation':
    'Cuộc trò chuyện trên Google Maps',
  'dashboards.number-whatsappconversation': 'Cuộc trò chuyện WhatsApp',
  'dashboards.number-instagramconversation': 'Cuộc trò chuyện trên Instagram',
  'dashboards.number-agentconversation': 'Cuộc trò chuyện của đại lý',
  'dashboards.number-amenityqueries': 'Truy vấn tiện ích',
  'dashboards.number-bookingenquiries': 'Truy vấn đặt chỗ',
  'dashboards.number-groupbookingenquiries': 'Yêu cầu đặt phòng theo nhóm',
  'dashboards.number-eventenquiries': 'Yêu cầu sự kiện',
  'dashboards.number-longstayenquiries': 'Yêu cầu ở lại dài hạn',
  'dashboards.number-totaltickets': 'Vé',
  'dashboards.number-returncustomer': 'Khách hàng trở lại',
  'dashboards.number-redirects': 'Chuyển hướng trang web',
  'dashboards.number-bookingengineleads':
    'Công cụ đặt chỗ khách hàng tiềm năng',
  'dashboards.number-roomnightsreferred': 'Số đêm trong phòng được giới thiệu',
  'dashboards.number-revenuereferred': 'Doanh thu được giới thiệu',
  'menu.bookingsmenu': 'Đặt chỗ',
  'menu.guests': 'Thông tin khách',
  'menu.whatsnew': 'Có gì mới',

  'forms.forms-title': 'Hình thức',
  'menu.formbuilder': 'Trình tạo Mẫu',
  "dashboards.trainAI": "Huấn luyện AI bằng tài liệu",
  "dashboards.uploadDocuments": "Tải tài liệu lên để giúp AI của bạn hiểu doanh nghiệp của bạn và hỗ trợ khách hàng giống như bạn. Bạn có thể thêm tệp ở định dạng .doc, .pdf hoặc .txt.",
  'dashboards.welcomeMessage': 'Tin nhắn chào mừng',
  'dashboards.personalizeGreeting': 'Cá nhân hóa cách chào đón khách hàng để phản ánh thương hiệu, phong cách và phép lịch sự của bạn, đảm bảo họ nhận được sự chào đón nồng nhiệt. Tùy chỉnh lời chào để thể hiện thương hiệu và tạo ấn tượng tốt.',
  'dashboards.addRoomDetails': 'Thêm chi tiết về từng phòng của bạn để khách có thể dễ dàng khám phá mọi thứ họ cần để chọn lựa phù hợp nhất và làm cho quy trình đặt phòng đơn giản và nhanh hơn.',
  'dashboards.trainAIFAQs': 'Huấn luyện AI bằng FAQs',
  'dashboards.manualQuestions': 'Một số câu hỏi không thể được trả lời bằng tài liệu hoặc tìm thấy trên trang web. Ở đây, bạn có thể thêm câu hỏi thủ công để đảm bảo khách hàng luôn có thông tin họ cần trong tay.',
  'dashboards.publishAI': 'Công bố AI để phản ánh các cập nhật mới nhất',
  'dashboards.retrainAfterChanges': 'Khi bạn thực hiện thay đổi trong Knowledge Hub hoặc biểu mẫu, hãy đảm bảo huấn luyện lại chatbot với thông tin đã cập nhật. Việc công bố AI của bạn đảm bảo chatbot cung cấp các câu trả lời chính xác và cập nhật nhất.',
  'dashboards.enhanceKnowledge': 'Nâng cao kiến thức AI bằng cách theo dõi các truy vấn chưa được trả lời',
  'dashboards.reviewUnanswered': 'Bất cứ khi nào AI không thể trả lời một câu hỏi hoặc chỉ cung cấp chi tiết hạn chế, bạn sẽ tìm thấy các truy vấn đó ở đây. Xem xét chúng để xác định các khoảng trống trong Knowledge Hub của bạn hoặc các câu hỏi độc đáo từ khách.',
  'dashboards.manageMedia': 'Quản lý phương tiện',
  'dashboards.mediaGallery': 'Bất cứ khi nào bạn tải lên hình ảnh như phòng, tiện nghi, logo hoặc avatar kỹ thuật số của bạn, chúng sẽ xuất hiện trong bộ sưu tập này, mang đến cho bạn một nơi trung tâm để quản lý hình ảnh trực quan và đảm bảo khách của bạn nhìn thấy điều gì làm cho doanh nghiệp của bạn trở nên độc đáo.',
  'dashboards.createForms': 'Tạo biểu mẫu dễ dàng và nhận thông báo mỗi khi có gửi đi.',
  'dashboards.manageForms': 'Tạo và quản lý biểu mẫu để thu thập thông tin khách hàng, thiết lập thông báo và tùy chỉnh chúng cho các ngôn ngữ khác nhau.',
  'dashboards.personalizeResponse': 'Cá nhân hóa phong cách phản hồi và cách tiến triển cuộc trò chuyện',
  'dashboards.controlConversation': 'Tính năng nâng cao này cho phép bạn định hình và kiểm soát cách các cuộc trò chuyện diễn ra với khách hàng của bạn qua các kênh khác nhau.',

  'menu.virtualfrontdesk': 'Lễ tân ảo',
  'menu.guestservice': 'Dịch vụ khách hàng',
  'virtual-front.common-questions': 'Câu hỏi thường gặp',
  'virtual-front.add-on-upsells': 'Tiện ích bổ sung & Bán thêm',
  'virtual-front.service-order': 'Dịch vụ đặt trước',
  //'virtual-front.guest-service-add-on-upsells': "Dịch vụ khách & Tiện ích bổ sung",
  'virtual-front.guest-service-add-on-upsells': 'Sổ khách kỹ thuật số',
  'virtual-front.outbound': 'nước ngoài',
  'virtual-messenger': 'Tin nhắn',

  'missed-response.missed-response-title': 'Tiêu đề phản hồi bị bỏ lỡ',
  //
  'content.allconversation': 'Tất cả cuộc trò chuyện',
  'content.active': 'Hoạt động',
  'content.tickets': 'Vé',
  'content.filter': 'Bộ lọc',
  'content.createtickets': 'Tạo vé',
  'content.conversation': 'Cuộc trò chuyện',
  'content.knowledgesearch': 'Tìm kiếm kiến thức',
  'content.reply': 'Trả lời',
  'content.visitorinfo': 'Thông tin khách truy cập',
  'content.callinfo': 'Thông tin cuộc gọi',
  'content.allinsights': 'Tất cả thông tin chi tiết',
  'content.availabilityrates': 'Khả dụng & Giá cả',
  'content.callback': 'Gọi lại',
  'content.close': 'Đóng',
  'content.sms': 'SMS',
  'content.timestamp': 'Dấu thời gian',
  'content.topics': 'Chủ đề',
  'content.callingparty': 'Bên gọi',
  'content.accountdomain': 'Miền tài khoản',
  'content.calledparty': 'Bên gọi đến',
  'content.recording': 'Ghi âm',
  'content.phonesystemoriginationcallid': 'ID cuộc gọi phát sinh từ hệ thống điện thoại',
  'content.phonesystemterminationcallid': 'ID cuộc gọi kết thúc hệ thống điện thoại',
  'content.uniqueconversationid': 'ID cuộc trò chuyện duy nhất',
  'content.regenerateinsights': 'Tạo lại thông tin chi tiết',
  'content.customersentiment': 'Cảm xúc khách hàng',
  'content.neutral': 'Trung lập',
  'content.customerreportedbroadbandoutage': 'Khách hàng báo cáo mất kết nối băng thông rộng và cung cấp ID khách hàng cùng ngày kích hoạt dịch vụ để được hỗ trợ.',
  'content.conversationinsights': 'Thông tin chi tiết cuộc trò chuyện',
  'content.broadbandoutage': 'Mất kết nối băng thông rộng',
  'content.customeridverification': 'Xác minh ID khách hàng',
  'content.serviceactivationdate': 'Ngày kích hoạt dịch vụ',
  'content.followups': 'Theo dõi',
  'content.actionneeded': 'Cần hành động',
  'content.uniqueConversationId': 'ID hội thoại duy nhất',
  'content.uniqueChatId': 'ID trò chuyện duy nhất',
  'content.recording&transcript': 'Ghi âm & Bản chép lời',
  'content.chatinsights': 'Phân tích chat',
  'content.visitedpages': 'Các trang đã ghé thăm',
  'content.deviceinfo': 'Thông tin thiết bị',
  'content.chatstartedonthispage': 'Chat được bắt đầu trên trang này',
  'content.prechatinfo': 'Thông tin trước chat',
  'content.notes': 'Ghi chú',
  'content.reassign': 'Phân công lại',
  'content.open': 'Mở',
  "content.dismiss": "Đóng",
  "content.add_placeholder": "Thêm giá trị giữ chỗ",
  "content.mobile_number": "Số điện thoại di động",
  "content.please_select": "Vui lòng chọn",
  'content.sendwhatsapp': 'Gửi tin nhắn WhatsApp',



  /* Missed Response */
  'feedback.missed-question': 'Câu hỏi bị bỏ sót',
  'feedback.conversation-summary': 'Tóm tắt cuộc trò chuyện',
  'feedback.dates-in-spanish': 'Ngày cần viết bằng tiếng Tây Ban Nha',
  'feedback.resolve': 'Giải quyết',
  'feedback.ignore': 'Bỏ qua',

  //integration
  // vi-VI
  'integration.select_properties': 'Chọn Thuộc tính',
  'integration.select_properties_enabled': 'Chọn các thuộc tính được kích hoạt thông qua tích hợp này',
  'integration.services_addons': 'Chọn Dịch vụ & Tiện ích',
  'integration.services_visible': 'Chọn dịch vụ & tiện ích sẽ hiển thị trên trang này',
  'integration.appearance': 'Giao diện',
  'integration.appearance_customize': 'Chọn tên trợ lý kỹ thuật số của bạn, biểu tượng và thiết lập màu sắc',
  'integration.booking_calendar': 'Lịch Đặt lịch',
  'integration.booking_calendar_style': 'Chọn kiểu cho cửa sổ bật lên lịch đặt lịch',
  'integration.nudges': 'Gợi ý',
  'integration.nudges_setup': 'Thiết lập tin nhắn chủ động để tương tác với khách truy cập trang web',
  'integration.position': 'Vị trí',
  'integration.position_control': 'Kiểm soát vị trí của tiện ích trò chuyện trên trang web của bạn',
  'integration.custom_fonts': 'Phông chữ Tùy chỉnh',
  'integration.custom_fonts_upload': 'Tải lên phông chữ tùy chỉnh để sử dụng cho trang',
  'integration.custom_css': 'CSS Tùy chỉnh',
  'integration.custom_css_usage': 'Sử dụng CSS để tùy chỉnh Compendium Kỹ thuật số của bạn',
  'integration.location': 'Vị trí',
  'integration.location_embed': 'Thêm URL vị trí nhúng của bạn',
  'integration.external_links': 'Liên kết Ngoại',
  'integration.external_links_add': 'Thêm các liên kết của bạn',
  'integration.language': 'Ngôn ngữ',
  'integration.widget_languages': 'Chọn ngôn ngữ cho tiện ích trò chuyện',
  'integration.chatbot_contact': 'Chatbot',
  'integration.chatbot_enable': 'Kích hoạt trợ lý kỹ thuật số của bạn',
  'integration.chatbot_security': 'Giữ Messenger của bạn an toàn',
  'integration.chatbot_trusted_pages': 'Liệt kê các trang tin cậy để hiển thị Chatbot',
  'integration.chatbot_publish': 'Xuất bản trợ lý kỹ thuật số của bạn',
  'integration.chatbot_install': 'Sao chép đoạn mã để cài đặt trợ lý kỹ thuật số của bạn',

};
export default viMessages;